export default interface BookingExtra {
  id: number
  amountCents: number
  name: string
  bookingId: number
  quantity: number
  valueType: BookingExtraValueTypes
  extraType: BookingExtraTypes
}

export enum BookingExtraValueTypes {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export enum BookingExtraTypes {
  Discount = 'discount',
  Extra = 'extra',
}
